module.exports = __webpack_public_path__ + "img/icone-codigo.83f5bce2.svg";